function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#495A95"
});

var _ref3 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 10,
  y: 10,
  width: 20,
  height: 20
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.4 10.4H29.6023V29.6H10.4V10.4Z",
  fill: "white"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.0012 10.4C17.3937 10.4 17.0667 10.411 16.0426 10.4578C15.0207 10.5044 14.3228 10.6667 13.7121 10.9041C13.0807 11.1494 12.5453 11.4777 12.0115 12.0114C11.4777 12.5452 11.1494 13.0807 10.9041 13.712C10.6667 14.3227 10.5044 15.0207 10.4578 16.0426C10.4111 17.0667 10.4 17.3936 10.4 20.0012C10.4 22.6087 10.4111 22.9356 10.4578 23.9597C10.5044 24.9816 10.6667 25.6795 10.9041 26.2902C11.1494 26.9216 11.4777 27.457 12.0115 27.9908C12.5453 28.5246 13.0807 28.8529 13.7121 29.0982C14.3228 29.3356 15.0207 29.4979 16.0426 29.5445C17.0667 29.5912 17.3937 29.6023 20.0012 29.6023C22.6087 29.6023 22.9356 29.5912 23.9597 29.5445C24.9816 29.4979 25.6796 29.3356 26.2903 29.0982C26.9216 28.8529 27.4571 28.5246 27.9909 27.9908C28.5246 27.457 28.8529 26.9216 29.0983 26.2902C29.3356 25.6795 29.4979 24.9816 29.5445 23.9597C29.5913 22.9356 29.6023 22.6087 29.6023 20.0012C29.6023 17.3936 29.5913 17.0667 29.5445 16.0426C29.4979 15.0207 29.3356 14.3227 29.0983 13.712C28.8529 13.0807 28.5246 12.5452 27.9909 12.0114C27.4571 11.4777 26.9216 11.1494 26.2903 10.9041C25.6796 10.6667 24.9816 10.5044 23.9597 10.4578C22.9356 10.411 22.6087 10.4 20.0012 10.4ZM20.0015 12.1295C22.5651 12.1295 22.8687 12.1393 23.8811 12.1855C24.8172 12.2282 25.3256 12.3846 25.6639 12.5161C26.1121 12.6903 26.4319 12.8983 26.7679 13.2343C27.1039 13.5703 27.3119 13.8901 27.4861 14.3383C27.6176 14.6766 27.774 15.185 27.8167 16.1211C27.8629 17.1335 27.8727 17.4372 27.8727 20.0008C27.8727 22.5644 27.8629 22.868 27.8167 23.8804C27.774 24.8166 27.6176 25.3249 27.4861 25.6632C27.3119 26.1114 27.1039 26.4312 26.7679 26.7672C26.4319 27.1032 26.1121 27.3112 25.6639 27.4854C25.3256 27.6169 24.8172 27.7733 23.8811 27.816C22.8689 27.8622 22.5653 27.872 20.0015 27.872C17.4377 27.872 17.1341 27.8622 16.1218 27.816C15.1857 27.7733 14.6773 27.6169 14.339 27.4854C13.8908 27.3112 13.571 27.1032 13.235 26.7672C12.8991 26.4312 12.691 26.1114 12.5168 25.6632C12.3853 25.3249 12.2289 24.8166 12.1862 23.8804C12.14 22.868 12.1303 22.5644 12.1303 20.0008C12.1303 17.4372 12.14 17.1335 12.1862 16.1211C12.2289 15.185 12.3853 14.6766 12.5168 14.3383C12.691 13.8901 12.899 13.5703 13.235 13.2343C13.571 12.8983 13.8908 12.6903 14.339 12.5161C14.6773 12.3846 15.1857 12.2282 16.1218 12.1855C17.1342 12.1393 17.4379 12.1295 20.0015 12.1295Z",
  fill: "#495A95"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2443 23.5097C18.4367 23.5097 16.9713 22.0444 16.9713 20.2368C16.9713 18.4291 18.4367 16.9637 20.2443 16.9637C22.0519 16.9637 23.5173 18.4291 23.5173 20.2368C23.5173 22.0444 22.0519 23.5097 20.2443 23.5097ZM20.2442 15.1955C17.4595 15.1955 15.202 17.4529 15.202 20.2377C15.202 23.0224 17.4595 25.2798 20.2442 25.2798C23.029 25.2798 25.2864 23.0224 25.2864 20.2377C25.2864 17.4529 23.029 15.1955 20.2442 15.1955Z",
  fill: "#495A95"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.3554 14.8216C26.3554 15.4846 25.8179 16.0221 25.1548 16.0221C24.4919 16.0221 23.9543 15.4846 23.9543 14.8216C23.9543 14.1586 24.4919 13.6211 25.1548 13.6211C25.8179 13.6211 26.3554 14.1586 26.3554 14.8216Z",
  fill: "#495A95"
});

var SvgIconInstagramOutline = function SvgIconInstagramOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconInstagramOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_instagram_outline.4af8bfe6.svg";
export { ForwardRef as ReactComponent };